import TextToSpeechBody from './TextToSpeechBody';

const TextToSpeechView = (props) => <TextToSpeechBody {...props} />;

export default TextToSpeechView;
